import React, { useEffect } from 'react';
import './Footer.scss';

const Footer = () => {
  useEffect(() => {
    // Footer Modal JavaScript - footer-pop-up.js'ten
    const setupFooterModal = () => {
      const modalTrigger = document.getElementById('aydinlatmaMetniLink');
      const modal = document.getElementById('aydinlatmaModal');
      const closeButton = document.querySelector('.modal-close-button');

      if (modalTrigger && modal && closeButton) {
        // Modal açma fonksiyonu
        const openModal = () => {
          modal.style.display = 'block';
          document.body.style.overflow = 'hidden';
          // Animasyon için küçük bir gecikme
          setTimeout(() => {
            modal.style.opacity = '1';
          }, 10);
        };

        // Modal kapama fonksiyonu
        const closeModal = () => {
          modal.style.opacity = '0';
          // Animasyon tamamlanana kadar bekle
          setTimeout(() => {
            modal.style.display = 'none';
            document.body.style.overflow = '';
          }, 300);
        };

        // Modal açma
        modalTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });

        // Modal kapama - X butonu
        closeButton.addEventListener('click', closeModal);

        // Modal kapama - dışarıya tıklama
        window.addEventListener('click', (e) => {
          if (e.target === modal) {
            closeModal();
          }
        });

        // Modal kapama - ESC tuşu
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.style.display === 'block') {
            closeModal();
          }
        });
      }
    };

    setupFooterModal();
  }, []);

    const footerStyle = {
    backgroundImage: 'url(/images/footer-bg.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <footer className="site-footer" id="iletisim" style={footerStyle}>
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Column 1: Logo & Contact */}
            <div className="footer-column footer-about">
              <div className="footer-logo">
                <img src="logos/wihte-turkish-logo.svg" alt="Hayat Finans Logo" className="footer-logo-finans" />
                <span className="footer-logo-separator"></span>
                <img src="logos/white-en-logo.svg" alt="Hayat Fintech Logo" className="footer-logo-fintech" />
              </div>
              <p className="footer-description">
                <img src="icons/mail.svg" alt="Mail" />
                <a href="mailto:info@hayatfintech.com">info@hayatfintech.com</a>
              </p>
              <p className="footer-description">
                <img src="icons/location.svg" alt="Location" />
                Altunizade Mahallesi Kısıklı Caddesi No:38 Üsküdar - İstanbul
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container">
                      <p className="copyright">Copyright © {new Date().getFullYear()} | Hayat Fintek, Hayat Holding ve Hayat Finans nezdinde faaliyet göstermektedir.</p>
          <div className="footer-bottom-links">
            <button type="button" id="aydinlatmaMetniLink" className="aydinlatma-link-button">Hayat Fintek Aydınlatma Metni</button>
          </div>
        </div>
      </div>

      {/* Aydınlatma Metni Modal */}
      <div id="aydinlatmaModal" className="modal">
        <div className="modal-content">
          <span className="modal-close-button">&times;</span>
          <h2>Hayat Fintek Aydınlatma Metni</h2>
          <div className="modal-text-content">
            <p><strong>HAYAT FİNTEK ÇÖZÜMLERİ A.Ş.</strong><br />
            <strong>KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN</strong><br />
            <strong>SADAKAT PROGRAMI AYDINLATMA METNİ</strong></p>

            <h4>AYDINLATMA METNİNİN AMACI</h4>
            <p>İşbu aydınlatma metni, HAYAT FİNTEK ÇÖZÜMLERİ A.Ş. ("Şirket") Hayat Pay Sadakat Programı'na ("Program") katılım sağlayan üyelerin kişisel verilerinin korunması konusunda 6698 sayılı Kişisel Verilerin Korunması Kanunu kapsamında aydınlatılması, kişisel verilerinin Şirket tarafından, hangi amaçlarla ve hukuki sebeplerle işlenebileceği, kimlere hangi amaçlarla aktarılabileceği hususunda bilgilendirilmesi amacıyla hazırlanmıştır.</p>

            <h4>VERİ SORUMLUSU</h4>
            <p>Veri Sorumlusu. HAYAT FİNTEK ÇÖZÜMLERİ A.Ş.'dir. Şirket, "Veri Sorumlusu" sıfatıyla, Sadakat Programı üyelerinin ("Üye") kişisel verilerini, işlenmelerini gerektiren amaçla sınırlı ve bu amaç ile bağlantılı ve ölçülü şekilde, hukuka ve dürüstlük kuralına uygun olarak işlemektedir.</p>

            <h4>İŞLENEN VERİ KATEGORİLERİ İLE KİŞİSEL VERİ İŞLEMENİN HUKUKİ SEBEBİ VE AMACI</h4>
            <p>Toplanan kişisel verileriniz, aşağıda yer verilen amaçlar ve hukuki sebepler ile Kanun'un 5. maddesinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde işlenebilecektir.</p>
            
            <div className="modal-table">
              <div className="modal-table-header">
                <div className="modal-table-cell header-kategori"><strong>Veri Kategorileri</strong></div>
                <div className="modal-table-cell header-amac"><strong>İşleme Amaçları</strong></div>
                <div className="modal-table-cell header-sebep"><strong>Hukuki Sebepler</strong></div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-kategori">
                  <p>Kimlik, İletişim, Finans, Konum, Üyelik</p>
                </div>
                <div className="modal-table-cell cell-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Program'a katılımınızın sağlanması ve bu kapsamda doğrulama/aktivasyon işlemlerinin gerçekleştirilmesi,</li>
                    <li>Kazandığınız geri kazanım bakiyesi, indirim uygulaması, puan ve hediye kodları/tutarları dahil olmak üzere Program kapsamındaki menfaatlerin hesaplanması, tarafınıza kullandırılması ve bilgi verilmesi</li>
                    <li>Kullanım süresi dolacak geri kazanım bakiyesi, indirim uygulaması, puan ve hediye kodları/tutarları dahil olmak üzere Program kapsamındaki menfaatlere ilişkin bilgilendirme yapılması,</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-sebep">
                  <p>Bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması kaydıyla, sözleşmenin taraflarına ait kişisel verilerin işlenmesinin gerekli olması</p>
                </div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-kategori">
                  <p>Kimlik, İletişim, Finans, Konum, Üyelik</p>
                </div>
                <div className="modal-table-cell cell-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Müşteri memnuniyeti ve kurumsal iletişim faaliyetlerinin planlanması ve icrası,</li>
                    <li>Müşteri iletişim bilgilerinin güncellenmesi,</li>
                    <li>Müşteri ilişkilerinin yürütülmesi,</li>
                    <li>Ticari faaliyetlerin gerçekleştirilmesi için iş birimlerimizin gerekli çalışmaları ve bağlı iş süreçlerini gerçekleştirmesi,</li>
                    <li>Şirketimizin Program kapsamındaki ticari ve iş stratejilerinin belirlenmesi ve uygulanması,</li>
                    <li>Bilgi güvenliği süreçlerinin yürütülmesi,</li>
                    <li>Talep ve şikâyet yönetimi,</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-sebep">
                  <p>Sözleşmenin ifası ile doğrudan ilgili olması kaydıyla sözleşmenin taraflarına ait verilerin işlenmesinin gerekli olması</p>
                </div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-kategori">
                  <p>Kimlik, İletişim, Finans, Konum, Üyelik</p>
                </div>
                <div className="modal-table-cell cell-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Resmi kurum taleplerinin yerine getirilmesi,</li>
                    <li>Yetkili kuruluşlara mevzuattan kaynaklı bilgi verilmesi,</li>
                    <li>Mevzuatta öngörülen saklama yükümlülüklerine uygunluğun sağlanması,</li>
                    <li>İlgili kişi başvurularının mevzuata uygun olarak yanıtlanması ve gerekli işlemlerin gerçekleştirilmesi,</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-sebep">
                  <p>Şirket'in hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması<br />Kanunlarda açıkça öngörülmesi</p>
                </div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-kategori">
                  <p>Kimlik, İletişim, Finans, Konum, Üyelik, Pazarlama</p>
                </div>
                <div className="modal-table-cell cell-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Program'a bağlılık oluşturma ve geliştirme çalışmalarının gerçekleştirilmesi,</li>
                    <li>Şirketimizin ürün ve hizmetlerinin pazarlama süreçlerinin gerçekleştirilmesi,</li>
                    <li>Program kapsamındaki pazarlama süreçlerinin gerçekleştirilmesi, profilleme, skorlama ve analiz faaliyetleri dahil olmak üzere sunulan ürün ve hizmetlerin beğeni, kullanım alışkanlıkları ve ihtiyaçlarınıza göre özelleştirilerek önerilmesi ve tanıtılması,</li>
                    <li>İletişim bilgilerinize SMS, e-posta ve arama yoluyla ticari elektronik ileti gönderilmesi.</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-sebep">
                  <p>Açık rızanızın bulunması halinde</p>
                </div>
              </div>
            </div>

            <h4>İŞLENEN KİŞİSEL VERİLERİN KİMLERE VE HANGİ AMAÇLA AKTARILABİLECEĞİ</h4>
            <p>Kişisel verileriniz aşağıda belirtilen taraflara, aşağıdaki amaçlar ve hukuki sebeplerle Kanun'un 8. maddesinde belirtilen kişisel verilerin aktarılmasına ilişkin kurallara uygun olarak aktarılabilecektir.</p>

            <div className="modal-table">
              <div className="modal-table-header">
                <div className="modal-table-cell header-aktarilan"><strong>Aktarılan Kişi/Kuruluşlar</strong></div>
                <div className="modal-table-cell header-aktarim-amac"><strong>Aktarım Amaçları</strong></div>
                <div className="modal-table-cell header-aktarim-sebep"><strong>Hukuki Sebepler</strong></div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-aktarilan">
                  <p>Kanunen yetkili kamu kurumları ve kanunen yetkili özel kuruluşlar ile yargı mercileri</p>
                </div>
                <div className="modal-table-cell cell-aktarim-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Yasal raporlama ve bilgi taleplerinin yerine getirilmesi,</li>
                    <li>Yasal denetim faaliyetlerinin yürütülmesi,</li>
                    <li>Hukuki süreçlerin işletilmesi,</li>
                    <li>Mevzuattan kaynaklı yükümlülüklerimizin yerine getirilmesi</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-aktarim-sebep">
                  <p>Şirketimizin hukuki yükümlülüğünü yerine getirebilmesi için zorunlu olması<br />Kanunlarda açıkça öngörülmesi</p>
                </div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-aktarilan">
                  <p>İş Ortakları (Program kapsamındaki anlaşmalı işyerlerini ile Hayat Holding Grup Şirketleri ve Hayat Finans Katılım Bankası A.Ş.'yi ifade etmektedir.)</p>
                </div>
                <div className="modal-table-cell cell-aktarim-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Program kapsamındaki menfaatlerin tarafınıza sunulabilmesi,</li>
                    <li>İş faaliyetlerimizin yürütülmesi</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-aktarim-sebep">
                  <p>Sözleşmenin ifası ile doğrudan ilgili olması kaydıyla sözleşmenin taraflarına ait verilerin işlenmesinin gerekli olması<br />İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusu olarak meşru menfaatler için veri işlenmesi</p>
                </div>
              </div>

              <div className="modal-table-row">
                <div className="modal-table-cell cell-aktarilan">
                  <p>Tedarikçiler (Hizmetlerimizin sunulabilmesi ve faaliyetlerimizin yürütülebilmesi için hizmet aldığımız destek hizmet kuruluşları, dış hizmet sağlayıcıları, bilişim teknolojisi altyapısı hizmeti aldığımız firmalar, hukuk büroları, avukatlar, yatırımcılar, tercümanlık büroları, danışmanlık şirketleri, bağımsız denetim şirketleri, kargo/kurye/dağıtım şirketleri, gözetim/denetim/arşiv firmaları vb. 3. taraf hizmet sağlayıcıları, Hayat Holding Grup Şirketleri ve Hayat Finans Katılım Bankası A.Ş. ifade etmektedir.)</p>
                </div>
                <div className="modal-table-cell cell-aktarim-amac">
                  <ul className="modal-amaclar-listesi">
                    <li>Program kapsamındaki menfaatlerin tarafınıza sunulması</li>
                    <li>İş faaliyetlerimizin yürütülmesi</li>
                  </ul>
                </div>
                <div className="modal-table-cell cell-aktarim-sebep">
                  <p>Sözleşmenin ifası ile doğrudan ilgili olması kaydıyla sözleşmenin taraflarına ait verilerin işlenmesinin gerekli olması<br />İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusu olarak meşru menfaatlerimiz için veri işlenmesinin zorunlu olması<br />Kanunlarda açıkça öngörülmesi</p>
                </div>
              </div>
            </div>

            <h4>KİŞİSEL VERİ TOPLAMANIN YÖNTEMİ</h4>
            <p>Kişisel verileriniz, yukarıda yer verilen amaçların yerine getirilmesi kapsamında elektronik ortamda Hayat Finans Mobil Uygulaması, kısa mesaj, e-posta kanalları, destek hizmeti kuruluşları, Hayat Finans Katılım Bankası A.Ş. ve Hayat Fintek Çözümleri A.Ş.'nin tüm uygulamaları ve dağıtım kanalları ile internet sitesi üzerinden toplanmaktadır.</p>

            <h4>İLGİLİ KİŞİNİN KANUN'UN 11. MADDESİNDE SAYILAN HAKLARI</h4>
            <p>Kişisel verilerinize ilişkin olarak Kanun'un 11. maddesi uyarınca aşağıdaki haklara sahip olduğunuzu bildiririz:</p>
            <ul>
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme,</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,</li>
              <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
              <li>Kanun ve ilgili diğer kanun hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme ve bu kapsamda yapılan işlemin kişisel verilerinizin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
              <li>İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
              <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme.</li>
            </ul>
            <p>Kanun kapsamındaki taleplerinizi <a href="mailto:kvkk@hayatfinans.com.tr" style={{color: 'blue'}}>kvkk@hayatfinans.com.tr</a> linki üzerinden iletebilirsiniz.</p>
            <p>Şirketimiz niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandıracaktır. Ancak, işlemin ayrıca bir maliyet doğurması halinde, Şirketimiz tarafından Kişisel Verileri Koruma Kurulu'nca belirlenen tarifedeki ücreti ödemeniz istenebilecektir.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
